import React, { useMemo } from "react";
import { MockedAuthManager } from "../../../contexts/AuthManager";
import { buildUser, buildWorkerProfile } from "../../factories";
import { ProfileType } from "../../../__generated__/graphql";
import type { Meta, StoryObj } from "@storybook/react";
import BankAccountEditorScreen from "../../../screens/profile-editor/BankAccountEditor";
import { MockedProvider } from "@apollo/client/testing";
import { MockedProfileSwitcherManager } from "../../../contexts/ProfileSwitcherManager";
import { createStackNavigator } from "@react-navigation/stack";

const Stack = createStackNavigator<{
    BankAccountEdit: undefined;
}>();

const StoryComponent = () => {
    const user = useMemo(() => buildUser({ workerProfile: buildWorkerProfile() }), []);

    return (
        <MockedAuthManager user={user}>
            <MockedProfileSwitcherManager profileType={ProfileType.Worker}>
                <MockedProvider mocks={[]}>
                    <Stack.Navigator initialRouteName="BankAccountEdit">
                        <Stack.Screen name="BankAccountEdit" component={BankAccountEditorScreen} />
                    </Stack.Navigator>
                </MockedProvider>
            </MockedProfileSwitcherManager>
        </MockedAuthManager>
    );
};

const meta = {
    title: "Screens/ProfileEditor/BankAccountEditor",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
